<script>
import {ref, onMounted, getCurrentInstance, computed} from "vue";
import { mapGetters, mapActions } from "vuex";
import adminContract2025List from "~/src/components/AdminContract2025List.vue";
import axios from 'axios';

export default {
  components: { adminContract2025List },
  activated() {
    console.log("Back to list, state is preserved");
    // optionally refresh data if you need
    // this.fetchGroupCodes()
  },
  deactivated() {
    console.log("Left list, but kept in cache");
  },
  
  setup() {
    const { proxy } = getCurrentInstance();
    const translatedAll = computed(() => proxy.$t('Barchasi'));

    const roleMenu = ref(false);
    const menuButton = ref(false);

    const isFiltering = ref(false);
    const menu = ref(false);
    const educationFacultyMenu = ref(false);
    const educationTypeMenu = ref(false);
    const educationLanguageMenu = ref(false);
    const groupMenu = ref(false);
    const regionMenu = ref(false);
    const districtMenu = ref(false);
    const genderMenu = ref(false);
    const discountMenu = ref(false);
    const paymentPercentMenu = ref(false);
    const documentStatusMenu = ref(false);
    const filters = ref({});
    const showFilters = ref(false);

    const group = ref([{ id: 0, name: translatedAll.value }]);
    const selectedGroup = ref([]);
    const noGroup = ref(false);
    const searchGroup = ref('');
    const codesLoading = ref(false);
    const codesError = ref(null);

    const hasRole = async (panel, op) => {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: {appPanel: panel, op}
        });
        return res.data === true;
      } catch {
        return false;
      }
    };

    const fetchGroupCodes = async () => {
      codesLoading.value = true;
      codesError.value = null;

      let canGetGroup = await hasRole("GURUHLAR", "READ");

      if (!canGetGroup) {
        codesLoading.value = false;
        return;
      }

      try {
        const { data } = await axios.get('api/groups/get/codes');
        const unique = Array.from(new Set((data || []).map(String)))
          .sort((a, b) => a.localeCompare(b, 'en'));
        group.value = [{ id: 0, name: translatedAll.value }].concat(
          unique.map((code, i) => ({ id: i + 1, name: code }))
        );
        const valid = new Set(group.value.map(g => g.id));
        selectedGroup.value = selectedGroup.value.filter(name => valid.has(name));
      } catch (e) {
        codesError.value = e?.response?.data?.message || e.message;
      } finally {
        codesLoading.value = false;
      }
    };

    onMounted(fetchGroupCodes);

    return { 
      roleMenu,
      menu, 
      educationFacultyMenu, 
      educationTypeMenu, 
      educationLanguageMenu, 
      groupMenu, 
      regionMenu, 
      districtMenu, 
      genderMenu,
      discountMenu,
      paymentPercentMenu,
      documentStatusMenu,
      isFiltering,
      filters,
      menuButton,
      showFilters,
      group,
      selectedGroup,
      noGroup,
      searchGroup,
      codesLoading,
      codesError,      
    };
  },

  data: (vm) => ({
    tab: Number(vm.$route.query.tab) || 0,
    isLoading: false,
    search: '',
    selected: [],
    dialog: false,
    buttonWidth: 0,
    application: {
      usatPassword: '' // bind your real data here
    },

    options: [
      { id: 0, name: vm.$t("Barchasi") },
      { id: 1, name: '1-' + vm.$t("bosqich") },
      { id: 2, name: '2-' + vm.$t("bosqich") },
      { id: 3, name: '3-' + vm.$t("bosqich") },
      { id: 4, name: '4-' + vm.$t("bosqich") },
      { id: 5, name: '5-' + vm.$t("bosqich") },
    ],

    searchEducationFaculty: '',
    selectedEducationFaculty: [],
    dialogEducationFaculty: false,

    educationFaculty: [
      { id: 1, name: 'Logistika' },
      { id: 2, name: 'Boshlang`ich ta`lim' },
      { id: 3, name: 'Moliya va moliyaviy texnologiyalar' },
      { id: 4, name: 'Tarix' },
    ],

    searchEducationType: '',
    selectedEducationType: [],
    dialogEducationType: false,

    educationType: [
      { id: 1, name: vm.$t("Kunduzgi ta'lim") },
      { id: 2, name: vm.$t("Kechki ta'lim") },
      { id: 3, name: vm.$t("Sirtqi ta'lim") },
      { id: 4, name: vm.$t("Kunduzgi 3-smena") },
    ],
    
    searchEducationLanguage: '',
    selectedEducationLanguage: [],
    dialogEducationLanguage: false,

    educationLanguage: [
      { id: 1, name: vm.$t("O'zbek") },
      { id: 2, name: vm.$t("Rus") },
      { id: 3, name: vm.$t("Ingliz") }
    ],

    searchRegion: '',
    selectedRegion: [],
    dialogRegion: false,
    
    region: [
      { id: 1, name: vm.$t("Barchasi") },
      { id: 2, name: "Toshkent viloyati" },
      { id: 3, name: "Qashqadaryo viloyati" },
      { id: 4, name: "Xorazm viloyati" },
      { id: 5, name: "Buhoro viloyati" },
      { id: 5, name: "Surxondaryo viloyati" },
    ],

    searchDistrict: '',
    selectedDistrict: [],
    dialogDistrict: false,
    
    district: [
      { id: 1, name: "Ohangaron" },
      { id: 2, name: "Xonqa" },
      { id: 3, name: "Yangibozor" },
      { id: 4, name: "Olmaliq" },
    ],

    searchGender: '',
    selectedGender: [],
    dialogGender: false,
    
    gender: [
      { id: 1, name: vm.$t("Erkak") },
      { id: 2, name: vm.$t("Ayol") },
    ],

    searchDiscount: '',
    selectedDiscount: [],
    dialogDiscount: false,
    
    discount: [
      {
          "id": 2,
          "promotion": 2000,
          "isPercent": false
      },
      {
          "id": 3,
          "promotion": 70,
          "isPercent": true
      }
    ],

    searchPaymentPercent: '',
    selectedPaymentPercent: [],
    dialogPaymentPercent: false,
    
    paymentPercent: [
      { id: 0, name: "0%" },
      { id: 1, name: "10%" },
      { id: 2, name: "25%" },
      { id: 3, name: "50%" },
      { id: 4, name: "75%" },
      { id: 5, name: "100%" },
    ],

    searchDocumentStatus: '',          // qidirish uchun qiymat
    selectedDocumentStatus: [],        // tanlangan filterlar
    dialogDocumentStatus: false,       // dialog uchun (agar kerak bo‘lsa)

    documentStatus: [
      { id: 0, name: vm.$t("Barchasi") },
      { id: 1, name: vm.$t("Qisman") },
      { id: 2, name: vm.$t("To'liq") },
    ],

    searchRole: '',          // qidirish uchun qiymat
    selectedRole: [],        // tanlangan filterlar
    dialogRole: false,       // dialog uchun (agar kerak bo‘lsa)

    role: [
      { id: 0, name: vm.$t("Imtihon") },
      { id: 1, name: vm.$t("Magistratura") },
    ],

    canCreateKontrakt: false

  }),

  watch: {
    menu(val) {
      if (val) {
        this.$nextTick(() => {
          const button = this.$refs.menuButton?.$el || this.$refs.menuButton;
          this.buttonWidth = button ? button.offsetWidth : 0;
        });
      }
    },

    // Year/kurs
    selected(val) {
      if (val.id === 0) {
        this.selected = this.options.map(o => o.name)
      }
    },

    // Faculty
    selectedEducationFaculty(val) {
      if (val.id === 0) {
        this.selectedEducationFaculty = this.educationFaculty.map(o => o.name)
      }
    },

    // Education Type
    selectedEducationType(val) {
      if (val.id === 0) {
        this.selectedEducationType = this.educationType.map(o => o.name)
      }
    },

    // Education Language
    selectedEducationLanguage(val) {
      if (val.id === 0) {
        this.selectedEducationLanguage = this.educationLanguage.map(o => o.name)
      }
    },

    // Group codes
    // selectedGroup(val) {
    //   if (val.id === 0) {
    //     this.selectedGroup = this.group.map(o => o.name)
    //   }
    // },

 


    // Region
    // selectedRegion(val) {
    //   // if "Barchasi" (id: 0) is selected, replace the selection with all real region ids
    //   if (val.includes(0)) {
    //     // all region ids except 0
    //     const allIds = this.region.filter(r => r.id !== 0).map(r => r.id);
    //     // avoid infinite loops: only set if it actually changed
    //     if (val.length !== allIds.length) {
    //       this.selectedRegion = allIds;
    //       return; // exit early, next tick will re-trigger applyFilters
    //     }
    //   }
    //   this.applyFilters();
    // },


    // District
    // selectedDistrict(val) {
    //   if (val.includes('Barchasi')) {
    //     this.selectedDistrict = this.district.map(o => o.name)
    //   }
    // },

    // Gender
    selectedGender(val) {
      if (val.id === 0) {
        this.selectedGender = this.gender.map(o => o.name)
      }
    },

    // Discount
    selectedDiscount(val) {
      if (val.id === 0) {
        this.selectedDiscount = this.discount.map(o => o.name)
      }
    },

    // Payment Percent
    selectedPaymentPercent(val) {
      if (val.id === 0) {
        this.selectedPaymentPercent = this.paymentPercent.map(o => o.name)
      }
    }
  },

  created() {
    this.INIT_COUNT();
    this.loadFaculties();
    this.fetchRegions();
    this.fetchDistricts();
      this.normalizeBosqichOptions(); // <— add this
    this.fetchPromotions();
  },  

  computed: {
    ...mapGetters("admin-contracts2025", ["GET_COUNT"]),
    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
    filteredOptions() {
      const s = this.search.toLowerCase();
      return this.options.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredEducationFaculty() {
      const s = this.searchEducationFaculty.toLowerCase();
      return this.educationFaculty.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredEducationType() {
      const s = this.searchEducationType.toLowerCase();
      return this.educationType.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredEducationLanguage() {
      const s = this.searchEducationLanguage.toLowerCase();
      return this.educationLanguage.filter((o) => o.name.toLowerCase().includes(s));
    },
    
    filteredRegion() {
      const s = this.searchRegion.toLowerCase();
      return (this.region || []).filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredDistrict() {
      const s = this.searchDistrict.toLowerCase();
      return (this.district || []).filter(o => o.name.toLowerCase().includes(s));
    },

    filteredGender() {
      const s = this.searchGender.toLowerCase();
      return this.gender.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredDiscount() {
      const s = this.searchDiscount.toLowerCase();
      return this.discount.filter((o) => {
      // Compose a label string for searching
      const label = o.isPercent
        ? `${o.promotion}%`
        : `${o.promotion} so'm`;
      return label.toLowerCase().includes(s);
      });
    },

    filteredPaymentPercent() {
      const s = this.searchPaymentPercent.toLowerCase();
      return this.paymentPercent.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredDocumentStatus() {
      const s = this.searchDocumentStatus.toLowerCase();
      return this.documentStatus.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredRole() {
      const s = this.searchRole.toLowerCase();
      return this.role.filter((o) => o.name.toLowerCase().includes(s));
    },
    
    filteredGroup() {
      const s = (this.searchGroup || '').toLowerCase();
      return (this.group || []).filter(o => (o.name || '').toLowerCase().includes(s));
    }

  },

  methods: {
    ...mapActions("admin-contracts2025", ["INIT_COUNT", "INIT_FILTERED_APPLICATIONS", "INIT_FACULTIES"]),

    async fetchRegions() {
      this.regionsLoading = true;
      this.regionsError = null;
      try {
        const { data } = await axios.get('admin/region?page=0&size=120&name=null&sortField=&sortOrder=asc', {
          headers: {
            Authorization: `Bearer ${this.GET_USER?.token || ''}`,
            'Accept-Language': 'uz',
          }
        });

        const regionList = (data?.content || []).map(region => ({
          id: region.id,
          name: region.names?.uz || region.names?.en || region.names?.ru || '---'
        }));

        this.region = [{ id: 0, name: this.$t('Barchasi') }, ...regionList];
        console.log(this.region)
      } catch (e) {
        this.regionsError = e?.response?.data?.message || e.message || 'Failed to load regions';
      } finally {
        this.regionsLoading = false;
      }
    },

    async fetchPromotions() {
      // this.promotionsLoading = true;
      // this.promotionsError = null;
      try {
        const { data } = await axios.get(
          "/admin/promotions"
        );
        this.discount = data;
      } catch (e) {
      //  this.promotionsError = e?.response?.data?.message || e.message || "Failed to load promotions";
      } finally {
      //  this.promotionsLoading = false;
      }
    },

    normalizeBosqichOptions() {
      // keep a single Barchasi at the top
      const rest = this.options.filter(o => o.id !== 0);
      this.options = [{ id: 0, name: this.$t('Barchasi') }, ...rest];

      // keep selected numeric & valid
      const valid = new Set(this.options.map(o => o.id));
      this.selected = (this.selected || []).filter(id => typeof id === 'number' && valid.has(id));
    },

    onBosqichChange(item) {
      const ALL = 0;                                  // id of "Barchasi"
      const allIds = this.options.map(o => o.id);     // [0,1,2,3,4,5]

      // wait for v-model to finish
      this.$nextTick(() => {
        const allNowChecked = this.selected.includes(ALL);

        if (item.id === ALL) {
          // Clicked Barchasi -> select all or clear all
          this.selected = allNowChecked ? allIds.slice() : [];
          this.applyFilters();
          return;
        }

        // Clicked a regular item
        // remove Barchasi if present
        this.selected = this.selected.filter(v => v !== ALL);

        // if all individual items are selected, auto-check Barchasi
        const indiv = allIds.filter(id => id !== ALL);
        const selIndiv = this.selected.filter(id => id !== ALL);
        if (selIndiv.length === indiv.length) {
          this.selected = allIds.slice();
        }

        this.applyFilters();
      });
    },

    onRegionChange(item) {
      const ALL = 0;                                // id of "Barchasi"
      const allIds = this.region.map(r => r.id);    // includes 0

      this.$nextTick(() => {
        const isAllNowChecked = this.selectedRegion.includes(ALL);

        if (item.id === ALL) {
          // User clicked "Barchasi": select-all if it's now checked, else clear all
          this.selectedRegion = isAllNowChecked ? allIds.slice() : [];
          this.applyFilters();
          return;
        }

        // User toggled a regular region
        // remove "Barchasi" if present
        this.selectedRegion = this.selectedRegion.filter(v => v !== ALL);

        // If now every individual is selected, auto-add "Barchasi"
        const indiv = allIds.filter(id => id !== ALL);
        const selIndiv = this.selectedRegion.filter(id => id !== ALL);
        if (selIndiv.length === indiv.length) {
          this.selectedRegion = allIds.slice();     // adds ALL + all ids
        }

        this.applyFilters();
      });
    },

    onDistrictChange(item) {
      const ALL = 0;                                      // id of "Barchasi"
      const allIds = this.district.map(d => d.id);        // includes 0

      this.$nextTick(() => {
        const isAllNowChecked = this.selectedDistrict.includes(ALL);

        if (item.id === ALL) {
          // Clicked Barchasi
          this.selectedDistrict = isAllNowChecked ? allIds.slice() : [];
          this.applyFilters();
          return;
        }

        // Clicked a regular district
        this.selectedDistrict = this.selectedDistrict.filter(v => v !== ALL);

        const indiv = allIds.filter(id => id !== ALL);
        const selIndiv = this.selectedDistrict.filter(id => id !== ALL);
        if (selIndiv.length === indiv.length) {
          this.selectedDistrict = allIds.slice(); // auto add ALL + all ids
        }

        this.applyFilters();
      });
    },

    onGroupChange(item) {
      const ALL = this.$t('Barchasi');
      const allValues = this.group.map(g => g.name); // includes 'Barchasi'

      this.$nextTick(() => {
        const hasAll = this.selectedGroup.includes(ALL);

        if (item.name === ALL) {
          // Clicked Barchasi: select all if now checked, clear all if unchecked
          this.selectedGroup = hasAll ? allValues.slice() : [];
          this.applyFilters();
          return;
        }

        // Clicked a regular group item — remove Barchasi if present
        this.selectedGroup = this.selectedGroup.filter(v => v !== ALL);

        // If all individual items are now selected, auto-add Barchasi
        const indiv = allValues.filter(v => v !== ALL);
        const selectedIndiv = this.selectedGroup.filter(v => v !== ALL);
        if (selectedIndiv.length === indiv.length) {
          this.selectedGroup = allValues.slice();
        }

        this.applyFilters();
      });
    },

    async fetchDistricts() {
      this.districtsLoading = true;
      this.districtsError = null;
      try {
        const { data } = await axios.get('admin/city?page=0&size=200&name=null&sortField=&sortOrder=asc', {
          headers: {
            Authorization: `Bearer ${this.GET_USER?.token || ''}`,
            'Accept-Language': 'uz',
          }
        });

        const districtList = (data?.content || []).map(city => ({
          id: city.id,
          name: city.names?.uz || city.names?.en || city.names?.ru || '---'
        }));

        this.district = [{ id: 0, name: this.$t('Barchasi') }, ...districtList];
      } catch (e) {
        this.districtsError = e?.response?.data?.message || e.message || 'Failed to load districts';
      } finally {
        this.districtsLoading = false;
      }
    },

    async fetchDistrictsByRegions(regionIds) {
      this.districtsLoading = true;
      this.districtsError = null;

      if (!regionIds || regionIds.length === 0) {
        this.district = [{ id: 0, name: this.$t('Barchasi') }];
        this.districtsLoading = false;
        return;
      }

      try {
        const allRequests = regionIds.map(regionId => {
          return axios.get(`admin/city/all/${regionId}`, {
            headers: {
              Authorization: `Bearer ${this.GET_USER?.token || ''}`,
              'Accept-Language': 'uz',
            }
          }).then(res => res.data || []).catch(() => []);
        });

        const results = await Promise.all(allRequests);
        const merged = results.flat();

        // Deduplicate by ID
        const seen = new Set();
        const uniqueDistricts = merged
          .filter(city => city?.id && !seen.has(city.id) && seen.add(city.id))
          .map(city => ({
            id: city.id,
            name: city.name || '---',
          }));

        this.district = [{ id: 0, name: this.$t('Barchasi') }, ...uniqueDistricts];
      } catch (e) {
        this.districtsError = e?.response?.data?.message || e.message || 'Failed to load districts';
      } finally {
        this.districtsLoading = false;
      }
    },

    async fetchDiscount() {
      
    },

    fetchCounts() {
      this.isFiltering = false;
      this.filters = {};
      
      this.INIT_COUNT();
    },

    async loadFaculties() {
      const faculties = await this.INIT_FACULTIES();
      console.log("Faculties loaded:", faculties);
      this.educationFaculty = faculties;
    },

    applyFilters() {
      console.log("selectedRole", this.selectedRole.length)
        // Helper: remove "Barchasi" ID (0) from an array
        const dropAll = arr => (arr || []).filter(id => id !== 0);

        // Mark filtering active if any filter has a value
        this.isFiltering =
          this.selectedEducationFaculty.length > 0 ||
          this.selected.length > 0 ||
          this.selectedEducationType.length > 0 ||
          this.selectedEducationLanguage.length > 0 ||
          this.selectedGroup.length > 0 ||
          this.noGroup ||
          this.selectedRegion.length > 0 ||
          this.selectedDistrict.length > 0 ||
          this.selectedGender.length > 0 ||
          this.selectedDiscount.length > 0 ||
          this.selectedPaymentPercent.length > 0 || 
          this.selectedDocumentStatus.length > 0 || 
          this.selectedRole.length > 0;

        // Prepare cleaned region and district IDs (no Barchasi=0)
        const regionIdsClean = dropAll(this.selectedRegion);
        const districtIdsClean = dropAll(this.selectedDistrict);
        const bosqichClean = (this.selected || []).filter(id => id !== 0);

        // Update districts list depending on region selection
        if (regionIdsClean.length > 0) {
          console.log("Fetching districts for selected regions:", regionIdsClean);
          this.fetchDistrictsByRegions(regionIdsClean);
        } else {
          this.district = [{ id: 0, name: this.$t('Barchasi') }];
          this.fetchDistricts(); // Reset to all districts
        }

        // Build final filters object for backend
        const filters = {
          kurs: bosqichClean.map(String),
          selectedEducationFaculties: this.selectedEducationFaculty.map(String),
          selectedEducationTypes: this.selectedEducationType.map(String),
          selectedEducationLanguages: this.selectedEducationLanguage.map(String),
          selectedGroups: this.selectedGroup.filter(v => v !== this.$t('Barchasi')).map(String),
          noGroup: !!this.noGroup,
          selectedRegions: regionIdsClean.map(String),
          selectedDistricts: districtIdsClean.map(String),
          selectedGenders: this.selectedGender.map(o => o === 1 ? "MALE" : "FEMALE"),
          selectedDiscounts: this.selectedDiscount.map(String),
          selectedPaymentPercents: this.selectedPaymentPercent.map(String),
          selectedDocumentStatus: this.selectedDocumentStatus.map(String),
          selectedRole: this.selectedRole.map(String),
        };

        // Save for use by your API call
        this.filters = filters;
    },

    onTap(tab) {
      window.open(`?tab=${tab}`, "_blank");
    },

    async fetchGroupCodes() {
      this.codesLoading = true;
      this.codesError = null;

      let canGetGroup = await this.hasRole("GURUHLAR", "READ");

      if (!canGetGroup) {
        this.codesLoading = false;
        return;
      }

      try {
        const { data } = await axios.get('api/groups/get/codes'); // adjust base URL if needed

        const unique = Array.from(new Set((data || []).map(String)));
        unique.sort((a, b) => a.localeCompare(b, 'en')); // or 'uz'

        const mapped = unique.map((code, i) => ({ id: i + 1, name: code }));

        this.group = [{ id: 0, name: this.$t('Barchasi') }, ...mapped];

        const validIds = new Set(this.group.map(g => g.id));
        this.selectedGroup = (this.selectedGroup || []).filter(name => validIds.has(name));
      } catch (e) {
        this.codesError = e?.response?.data?.message || e.message || 'Failed to load group codes';
      } finally {
        this.codesLoading = false;
      }
    },

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: { appPanel: panel, op }
        });
        return res.data === true;
      } catch {
        return false;
      }
    }


  },

  async mounted() {
    this.canExport = await this.hasRole("KONTRAKT_25_26", "EXCEL");
    this.canCreateKontrakt = await this.hasRole('KONTRAKT_25_26', 'CREATE');  }
  };
</script>

<template>
  <div>
    <div style="margin-bottom: 24px; display: flex; justify-content: flex-end; padding-right: 20px;">
      <v-btn
        class="filter-btn"
        elevation="2"
        large
        rounded
        @click="showFilters = !showFilters"
      >
        <img src="../../assets/filter.svg" alt="Filter Icon" style="margin-right: 8px;">
      </v-btn>
    </div>

    <v-fade-transition>
      <v-container v-if="showFilters" fluid>
        <div class="filter-row">
          <v-menu
            ref="roleWrapper"
            v-model="roleMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedRole.length
                  ? (() => {
                    const names = role
                    .filter(f => selectedRole.includes(f.id))
                    .map(f => f.name);
                    if (names.length === 1) return names[0];
                    if (names.length > 1) {
                    const first = names[0];
                    return `${first}, ..`;
                    }
                    return $t("O'QUV TURI");
                  })()
                  : $t("O'QUV TURI")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchRole"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredRole"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedRole"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="roleMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="menuWrapper"
            v-model="menu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">{{ selected.toString() || $t('bosqich').toUpperCase() }}</v-btn>
            </template>

            <v-card :style="{ 
              maxWidth: '274px', 
              backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',  
              height: 'max-content',
              zIndex: 1000
            }">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selected"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="onBosqichChange(item)"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="menu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          
          <v-menu
            ref="educationFacultyWrapper"
            v-model="educationFacultyMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="button-primary"
                v-bind="attrs"
                v-on="on"
                style="max-width: 274px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{
                  selectedEducationFaculty.length
                  ? (() => {
                    const names = educationFaculty
                      .filter(f => selectedEducationFaculty.includes(f.id))
                      .map(f => f.name);
                    if (names.length === 1) return names[0];
                    if (names.length > 1) {
                      const first = names[0];
                      return `${first}, ..`;
                    }
                    return $t("TA'LIM YO'NALISHI");
                    })()
                  : $t("TA'LIM YO'NALISHI")
                }}
                </v-btn>
            </template>

            <v-card :style="{ 
              maxWidth: '274px',
              maxHeight: '400px', 
              backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',  
            }">
              <v-card-title>
                <v-text-field
                  v-model="searchEducationFaculty"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredEducationFaculty"
                    :key="item.id"
                    :label="item.name + ' - ' + item.mvdir"

                    :value="item.id"
                    v-model="selectedEducationFaculty"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="menu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="educationTypeWrapper"
            v-model="educationTypeMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedEducationType.length
                  ? (() => {
                    const names = educationType
                      .filter(f => selectedEducationType.includes(f.id))
                      .map(f => f.name);
                    if (names.length === 1) return names[0];
                    if (names.length > 1) {
                      const first = names[0];
                      return `${first}, ..`;
                    }
                    return $t("TA'LIM SHAKLI");
                    })()
                  : $t("TA'LIM SHAKLI")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchEducationType"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredEducationType"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedEducationType"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="educationTypeMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="educationLanguageWrapper"
            v-model="educationLanguageMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedEducationLanguage.length
                    ? educationLanguage
                        .filter((f) => selectedEducationLanguage.includes(f.id))
                        .map((f) => f.name)
                        .join(', ')
                    : $t("TA'LIM TILI")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchEducationLanguage"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredEducationLanguage"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedEducationLanguage"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="educationLanguageMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="groupWrapper"
            v-model="groupMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedGroup.length
                  ? (() => {
                    const names = group
                      .filter(f => selectedGroup.includes(f.name))
                      .map(f => f.name);
                    if (names.length === 1) return names[0];
                    if (names.length > 1) {
                      const first = names[0];
                      return `${first}, ..`;
                    }
                    return $t("GURUH");
                    })()
                  : (noGroup ? $t("Guruh biriktirilmagan") : $t("GURUH"))
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchGroup"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <template v-for="item in filteredGroup">
                    <v-checkbox
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                      v-model="selectedGroup"
                      @change="onGroupChange(item)"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                    />
                    <!-- own row right under "Barchasi" -->
                    <v-checkbox
                      v-if="item.id === 0 || item.name === 'Barchasi'"
                      :key="'no-group-' + item.id"
                      v-model="noGroup"
                      :label="$t('Guruh biriktirilmagan')"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="width: 100%;"
                      @change="applyFilters"
                    />
                  </template>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="groupMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>


          <v-menu
            ref="regionWrapper"
            v-model="regionMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedRegion.length
                  ? (() => {
                  const names = region
                    .filter(f => selectedRegion.includes(f.id))
                    .map(f => f.name);
                  if (names.length === 1) return names[0];
                  if (names.length > 1) {
                    const first = names[0];
                    return `${first}, ..`;
                  }
                  return $t("VILOYAT");
                  })()
                  : $t("VILOYAT")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchRegion"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredRegion"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedRegion"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="onRegionChange(item, $event)"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="regionMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="districtWrapper"
            v-model="districtMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedDistrict.length
                  ? (() => {
                  const names = district
                    .filter(f => selectedDistrict.includes(f.id))
                    .map(f => f.name);
                  if (names.length === 1) return names[0];
                  if (names.length > 1) {
                    const first = names[0];
                    return `${first}, ..`;
                  }
                  return $t("TUMAN");
                  })()
                  : $t("TUMAN")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchDistrict"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredDistrict"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedDistrict"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="onDistrictChange(item)"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="districtMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="genderWrapper"
            v-model="genderMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedGender.length
                    ? gender
                        .filter((f) => selectedGender.includes(f.id))
                        .map((f) => f.name)
                        .join(', ')
                    : $t("JINS")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchGender"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredGender"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedGender"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="genderMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          

          <v-menu
            ref="discountWrapper"
            v-model="discountMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedDiscount.length
                  ? (() => {
                  const names = discount
                    .filter(f => selectedDiscount.includes(f.id))
                    .map(f => f.isPercent ? `${f.promotion}%` : `${f.promotion} so'm`);
                  if (names.length === 1) return names[0];
                  if (names.length > 1) {
                    const first = names[0];
                    return `${first}, ..`;
                  }
                  return $t("CHEGIRMA");
                  })()
                  : $t("CHEGIRMA")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchDiscount"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredDiscount"
                    :key="item.id"
                    :label="item.isPercent ? `${item.promotion}%` : `${item.promotion} so'm`"
                    :value="item.id"
                    v-model="selectedDiscount"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="discountMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="paymentPercentWrapper"
            v-model="this.paymentPercentMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedPaymentPercent.length
                  ? (() => {
                  const names = paymentPercent
                    .filter(f => selectedPaymentPercent.includes(f.id))
                    .map(f => f.name);
                  return names.join(", ");

                  return $t("TO'LOV FOIZI");
                  })()
                  : $t("TO'LOV FOIZI")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchPaymentPercent"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredPaymentPercent"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedPaymentPercent"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="paymentPercentMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
            ref="documentStatusWrapper"
            v-model="documentStatusMenu"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedDocumentStatus.length
                  ? (() => {
                    const names = documentStatus
                    .filter(f => selectedDocumentStatus.includes(f.id))
                    .map(f => f.name);
                    if (names.length === 1) return names[0];
                    if (names.length > 1) {
                    const first = names[0];
                    return `${first}, ..`;
                    }
                    return $t("HUJJATLARI");
                  })()
                  : $t("HUJJATLARI")
                }}
              </v-btn>
            </template>

            <v-card
              :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                  v-model="searchDocumentStatus"
                  :label="$t('Qidiruv')"
                  clearable
                  hide-details
                  dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text style="max-height: 280px; overflow-y: auto;">
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                    v-for="item in filteredDocumentStatus"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-model="selectedDocumentStatus"
                    hide-details
                    dense
                    class="mr-4 mb-2"
                    style="min-width: 120px;"
                    @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="documentStatusMenu = false">{{$t("Close")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          
          
          <!-- <v-text-field
            v-model="modernInput"
            label="Universal qidiruv"
            outlined
            dense
            rounded
            clearable
            style="min-width: 220px;"
          /> -->
        </div>


      </v-container>
    </v-fade-transition>

     <v-container
      v-if="canCreateKontrakt"
      fluid
      class="royal-row"
      role="group"
      aria-label="Contract stats">
      <div class="royal-grid">
        <!-- ALL -->
        <v-card
          class="royal-card royal--all"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="$emit('select','ALL')"
        >
          <div class="royal-title" v-text="$t('All Contract')" />
          <div class="royal-count">{{ GET_COUNT.ALL | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: '100%' }"></span>
          </div>
        </v-card>

        <!-- NOT PAID -->
        <v-card
          class="royal-card royal--not"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="$emit('select','NOT_PAID')"
        >
          <div class="royal-title">{{ $t('Not Paid Contract') }}</div>
          <div class="royal-count">{{ GET_COUNT.NOT_PAID | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: ((GET_COUNT.NOT_PAID||0)/(GET_COUNT.ALL||1)*100).toFixed(0)+'%' }"></span>
          </div>
        </v-card>

        <!-- HALF PAID -->
        <v-card
          class="royal-card royal--half"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="$emit('select','HALF_PAID')"
        >
          <div class="royal-title">{{ $t('Half Paid Contract') }}</div>
          <div class="royal-count">{{ GET_COUNT.HALF_PAID | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: ((GET_COUNT.HALF_PAID||0)/(GET_COUNT.ALL||1)*100).toFixed(0)+'%' }"></span>
          </div>
        </v-card>

        <!-- PAID -->
        <v-card
          class="royal-card royal--paid"
          elevation="0"
          :ripple="true"
          role="button"
          tabindex="0"
          @click="$emit('select','PAID')"
        >
          <div class="royal-title">{{ $t('Paid Contract') }}</div>
          <div class="royal-count">{{ GET_COUNT.PAID | sum }}</div>
          <div class="royal-meter">
            <span :style="{ width: ((GET_COUNT.PAID||0)/(GET_COUNT.ALL||1)*100).toFixed(0)+'%' }"></span>
          </div>
        </v-card>
      </div>
    </v-container>


    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-card class="position-relative" outlined style="overflow: hidden;">
            <v-tabs v-model="tab" color="accent">
              <v-tab
                @click.ctrl="onTap(0)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('All Contract')"
              />
              <v-tab
                @click.ctrl="onTap(1)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('Not Paid Contract')"
              />
              <v-tab
                @click.ctrl="onTap(2)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('Half Paid Contract')"
              />
              <v-tab
                @click.ctrl="onTap(3)"
                :disabled="isLoading"
                class="transform-none tab-upper"
                v-text="$t('Paid Contract')"
              />
            </v-tabs>

            <admin-contract2025-list
              @loading="(v) => (isLoading = v)"
              @reload="fetchCounts"
              v-model="tab"
              :isFiltering="isFiltering"
              @update:isFiltering="isFiltering = $event"
              :filters="filters"
            />
          </v-card>
        </v-col>
        <!-- <div >
        <v-btn small color="primary">EXEL EXPORT</v-btn>
      </div> -->
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
.card-title {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.527);

  margin-bottom: 20px;
  padding-bottom: 10px;

  font-weight: 500;
  font-size: 18px;

  text-transform: uppercase;

  text-align: center;
}

.card-count {
  font-size: 24px;
  font-weight: 500;

  color: white;

  text-align: center;
}

.card-table {
  width: 100%;
  box-shadow: none;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.right-form {
  padding: 15px 15px 10px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.right-form div {
  width: 300px;
  height: 60px;
}

._cards-wrap {
  @media only screen and (max-width: 1200px) {
    > div {
      margin: 20px 0;
    }
  }

  @media only screen and (min-width: 1200px) {
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: calc(100% / 3 - 16px);
    padding: 0 16px;
}
.v-menu__content.theme--light.menuable__content__active {
    background: #FFF;
}

.v-menu__content.theme--dark.menuable__content__active {
    background: #1a1b23;
}
// .v-input.v-input--hide-details.v-input--dense.theme--light.v-text-field.v-text-field--is-booted {
//     display: block;
//   min-width: 100%;
// }
// .v-card__title {
//   display: block;
//   min-width: 100%;

// }
.button-primary {
  background-color: #ffffff;
  border: 1px solid #d0d5dd;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 10px;
  transition: all 0.15s ease-in-out;
  box-shadow: none;
  cursor: pointer;
  text-transform: none;
}

.button-primary:hover {
  background-color: #f9fafb;
  border-color: #c0c7d0;
}

.button-primary:active {
  background-color: #f0f2f5;
  box-shadow: none;
}

.button-primary--selected {
  background-color: #2e90fa;
  border-color: #2e90fa;
  color: #ffffff;
  box-shadow: none;
}

.filter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: #f5f5f5 !important;
  color: #f5f5f5;
  font-size: 15px;
  font-weight: 500;
  padding: 10px 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: none;
  border: 1px solid #d0d5dd;
  text-transform: uppercase;
  min-width: 10px!important;
  border-radius: 20px;
  padding: 0 12.555556px!important;
}

.filter-btn img {
  width: 20px;
  height: 20px;
  object-fit: cover;
  margin-right: 0!important;
}

.filter-btn:hover {
  background-color: #1570ef;
}

.filter-btn:active {
  background-color: #175cd3;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

// restyling
$radius: 14px;
$gap: 14px;
$line: #e6e8ec;
$ink: #0f172a;
$muted: #667085;

/* royal accents */
$royal-blue:   #3451e6;  // All
$imperial-red: #c81e1e;  // Not paid
$amber-gold:   #b88300;  // Half paid
$emerald:      #148b4b;  // Paid

.royal-row { padding: 8px 12px; }
.royal-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: $gap;
  @media (max-width: 1280px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 960px)  { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 560px)  { grid-template-columns: 1fr; }
}

.royal-card {
  position: relative;
  overflow: hidden; /* keep stripe inside radius */
  cursor: pointer;
  background: #fff;
  border: 1px solid $line;
  border-radius: $radius;
  padding: 16px;
  min-height: 92px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;

  transition: border-color .18s ease, transform .18s ease, background-color .18s ease;
  outline: none;

  /* full-bleed top stripe */
  &::before {
    content: "";
    position: absolute;
    left: 0; right: 0; top: 0;
    height: 4px; background: transparent;
  }

  /* subtle interactions */
  &:hover  { border-color: #d7d9df; }
  &:active { }
  &:focus { outline: none; }

  /* hover wave */
  &::after {
    content: "";
    position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,.03), transparent);
    transform: translateX(-100%); pointer-events: none;
  }
  &:hover::after { animation: wave 1200ms ease; }

  /* initial mount reveal */
  animation: slideUpFade .38s ease both;
}
.royal-card:nth-child(1){ animation-delay: 40ms; }
.royal-card:nth-child(2){ animation-delay: 80ms; }
.royal-card:nth-child(3){ animation-delay: 120ms; }
.royal-card:nth-child(4){ animation-delay: 160ms; }

.royal-title{
  color: $muted;
  font-size: 12px; line-height: 1;
  letter-spacing: .08em;
  text-transform: uppercase;
  font-weight: 700;
}
.royal-count{
  color: $ink; /* stays black */
  font-weight: 900;
  font-size: clamp(24px, 3.6vw, 36px);
  line-height: 1.05;
  letter-spacing: -0.2px;
  font-variant-numeric: tabular-nums lining-nums;
}

/* ratio meter */
.royal-meter{
  height: 6px; margin-top: 6px;
  border-radius: 999px; background: #f1f3f5; overflow: hidden;
  > span{ display:block; height:100%; width:0%; transition: width .45s cubic-bezier(.2,.8,.2,1); }
}

/* per-variant colors (no CSS vars) */
.royal-card.royal--all  { &::before{ background:$royal-blue;   } .royal-meter>span{ background:$royal-blue;   } }
.royal-card.royal--not  { &::before{ background:$imperial-red; } .royal-meter>span{ background:$imperial-red; } }
.royal-card.royal--half { &::before{ background:$amber-gold;   } .royal-meter>span{ background:$amber-gold;   } }
.royal-card.royal--paid { &::before{ background:$emerald;      } .royal-meter>span{ background:$emerald;      } }

/* animations */
@keyframes wave {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
@keyframes slideUpFade {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* reduced motion */
@media (prefers-reduced-motion: reduce) {
  .royal-card,
  .royal-meter>span { transition: none; animation: none; }
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-row > * {
  flex: 0 1 calc(33.333% - 11px);
  min-width: 0;
  width: calc(33.333% - 11px);
}

.filter-row ::v-deep .button-primary {
  width: 100%;
}

@media (max-width: 600px) {
  .filter-row > * { flex: 1 1 100% !important; width: 100% !important; }
}
</style>